export default "__VITE_ASSET__DLj9Efmy__"